// extracted by mini-css-extract-plugin
module.exports = {"msgContainer":"MessageBox_msgContainer__2g_Ua","lastMsgContainer":"MessageBox_lastMsgContainer__1LMHK","contactName":"MessageBox_contactName__1CxHV"};